export default __webpack_public_path__ + "static/ML-card-4325ec21f96ef04c700e58af5882075c.svg";